import Image from 'next/image';
import { CheckmarkIcon } from '@/icons';
import LogoExclamationDot from '@/illustrations/LogoExclamationDot';
import BookDemoForm from '../BookDemoForm';

const ProBenefits = [
  'Genom vårt enkla gränssnitt får du en snabb överblick av bostadsmarknadsläget för successions- och nyproduktionsmarknaden samt bostadsrättsföreningar.',
  'Unika nyckeltal ger dig indikationer om vart bostadsmarknaden är på väg.',
  'Veckofärsk data.',
];

const ProBenefitsDisplay = () => {
  return (
    <div className='tablet:flex-col-reverse relative flex justify-center'>
      <div className='relative z-10 max-w-lg'>
        <h2 className='mobile:text-lg text-xl'>Varför Booli Pro?</h2>
        <p className='tablet:text-3xl mobile:text-2xl mt-1 text-4xl font-semibold'>
          Fördelarna med att använda Booli Pro
        </p>
        <ul className='mt-6'>
          {ProBenefits.map((benefit) => {
            return (
              <li
                className='mb-2 flex'
                key={benefit}
              >
                <span>
                  <CheckmarkIcon className='text-bui-color-orange m-2 w-6' />
                </span>
                <p>{benefit}</p>
              </li>
            );
          })}
        </ul>
        <p className='mt-6 mb-6'>Gör som över 100 företag och börja använda Booli Pro!</p>
        <BookDemoForm />
      </div>
      <div className='relative flex h-auto w-full min-w-[55%] items-center'>
        <div
          className='tablet:relative tablet:mt-4 tablet:w-full tablet:translate-x-0 tablet:translate-y-0
            pointer-events-none absolute left-4 flex aspect-square w-full items-center justify-center'
        >
          <Image
            quality={100}
            alt='Field with newly constructed buildings in the background'
            src={'/images/LandingPage/macbook_pro.png'}
            fill={true}
            className='z-10'
            sizes='(max-height:24px) (max-width:96px)'
          />
          <LogoExclamationDot className='tablet:w-[90%] w-[80%] -translate-x-2 opacity-50' />
        </div>
      </div>
    </div>
  );
};

export default ProBenefitsDisplay;
